// extracted by mini-css-extract-plugin
module.exports = {"c-services":"_025a50318d--c-services--3NmGH"};